import { useState,useEffect } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Select, Space, Spin, Table as AntTable, Tabs, Tag } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import DataType from "../../../Functions/Traitement/DataperiodMCompteRegpt";
import DataType2 from "../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataType3 from "../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataType4 from "../../../Functions/Traitement/DataperiodMCompteRegpt4";
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Alert, Box, Grid, TextField, Typography } from '@mui/material';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import { apiEndpoints } from '../../../config';
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/MComptesRegroup';
import Demande from '../../../Models/McomptesPretEtDecouvert';
import Demande2 from '../../../Models/MComptesOperatSysteme';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import  { ColumnsType } from 'antd/es/table';
import DataPeriod1 from "../../../Functions/Traitement/DataperiodMCompteRegpt";
import DataPeriod2 from "../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataPeriod3 from "../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataPeriod4 from "../../../Functions/Traitement/DataperiodMCompteRegpt4";
import CompteRegroupe from "../../../Models/CompteRegroup";
//import { IconButton, InputAdornment, Paper,  TablePagination, TableRow,TableBody, TableCell, TableContainer, TableHead } from '@mui/material';
import { IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import BlockIcon from '@mui/icons-material/Block';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import CheckIcon from '@mui/icons-material/Check';
//import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import { fetchDataTable, fetchDataTable2 } from "../../../utilitaires/globalFunction";
import { normalizeKeysToUppercase } from "../../../utilitaires/globalFunction";
import { Check, CheckCircle } from "@mui/icons-material";
import McomptesPretEtDecouvert from "../../../Models/McomptesPretEtDecouvert";
import { maxHeaderSize } from "http";

//pour les commis
let searchCommis: ParamsPicklist = { CodeAgence: '', Table: "COMMIS", Colonne1: "CODCOM", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }


const ComptesPretEtDecouvert = () => {
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Ttable, SetTtable] = useState("")
    const [Nnum, SetNnum] = useState("")
    const [Colon, setColon] = useState("")
    const [Columm, setColumn] = useState<any>()

    const [DataBranch, SetDataBranch] = useState<McomptesPretEtDecouvert[]>([]);
          const [currentDataBranch, setCurrentDataBranch] = useState<McomptesPretEtDecouvert | null>(null);
            
        const [searchTerm, setSearchTerm] = useState('');
            const [page, setPage] = useState(0); // Page actuelle
             const [rowsPerPage, setRowsPerPage] = useState(5); // Tu peux ajuster le nombre par défaut ici
            const [error, setError] = useState<string | null>(null);
              const [loading2, setLoading2] = useState(false);
            const [choix, setChoix] = useState('I');
        
    const [donnees, setData] = useState<any[]>([]);
    const onChange = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
    };

    // usestate pour la recherche 
    const [SearchR, SetSearchR] = useState<string>("");




    const dataOption2: DataSelect[] = [
        { label: " Compte de regroupement", value: "PLANCP" },
        { label: " Compte intérêts et commission", value: "IC" },
        { label: " Compte de prêts", value: "TYPEPRET" },
        { label: " Compte produit opération", value: "OPERAT" }
    ]

    //pour la selection de la table
    //let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: Ttable, Colonne1: Nnum, Colonne2: Colon, Colagence: '101', Choix: 22 }
    let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "TYPEPRET", Colonne1: "TYPEPRET", Colonne2: "LIBELLE", Colagence: '', Choix: 22 }
  let searchCompte: ParamsPicklist = { CodeAgence: Perss.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '', Choix: 22 }


  
    

  

    useEffect(() => {
        // charge la liste globale des comptes pret/decouvert (onglet 2)
        chargerListeTp();
    }, []);

        

    function Getselectcli() {
        setData([])
        form.setFieldValue("idplan", "")
        form.setFieldValue("lib_idplan", "")
            SetTtable("PLANCP")
            SetNnum("IDPLAN")
            setColon("LIBELL")
           // setColumn(columns1)

        // if (form.getFieldValue("categorie") == "PLANCP") {

        //     SetTtable("PLANCP")
        //     SetNnum("IDPLAN")
        //     setColon("LIBELL")
        //     setColumn(columns1)

        // } else if (form.getFieldValue("categorie") == "IC") {
        //     SetTtable("COMMIS")
        //     SetNnum("CODCOM")
        //     setColon("LIBELL")
        //     setColumn(columns2)
        // } else if (form.getFieldValue("categorie") == "TYPEPRET") {
        //     SetTtable("TYPEPRET")
        //     SetNnum("TYPEPRET")
        //     setColon("LIBELLE")
        //     setColumn(columns3)
        // } else if (form.getFieldValue("categorie") == "OPERAT") {
        //     SetTtable("OPERAT")
        //     SetNnum("CODOPE")
        //     setColon("LIBELL")
        //     setColumn(columns4)
        // } else {
        //     SetTtable("")
        //     SetNnum("")
        //     setColumn("")
        // }
    }

       // Fonction pour convertir un objet avec des clés en majuscules
   
    // 📄 Filtrage des données en fonction du terme de recherche
      const filteredDataBranch = DataBranch.filter((item) =>
        Object.values(item).some(val =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );

    // ====================================================================
    // NOUVEAU FLOW : comptes pret et decouvert par type de pret
    // Choix du TYPEPRET -> toutes les agences -> pour chaque agence les 10
    // comptes GL (une ligne ComptesTypepret par agence, sans cote part).
    // Meme logique que les comptes de regroupement.
    // ====================================================================
    // Champs comptes mappes dans ComptesTypepret (prop = nom dans le payload)
    const CHAMPS_TP: { prop: string; label: string }[] = [
        { prop: 'CptIntImp',     label: 'Cpte int impayé' },
        { prop: 'CptTvaImp',     label: 'Cpte tva impayé' },
        { prop: 'CptIntPaie',    label: 'Cpte int payé' },
        { prop: 'CptComptax',    label: 'Cpte tva payée' },
        { prop: 'CptPenPaie',    label: 'Cpte pénalité' },
        { prop: 'CptPromess',    label: 'Cpte promesse' },
        { prop: 'CptGaran',      label: 'Cpte garantie' },
        { prop: 'CptIntDout',    label: 'Cpte int douteux' },
        { prop: 'CptTvaDout',    label: 'Cpte tva douteuse' },
        { prop: 'CptProvCrdout', label: 'Cpte provision douteuse' },
    ];

    // Lit un champ d'une ligne quelle que soit la casse de la cle
    const champTp = (r: any, prop: string) =>
        String(r[prop] ?? r[prop.toUpperCase()] ?? r[prop.charAt(0).toLowerCase() + prop.slice(1)] ?? '');

    const [typepretSel, setTypepretSel] = useState('');
    const [activeTab, setActiveTab] = useState('1');
    const [agencesTp, setAgencesTp] = useState<{ codage: string; libelle: string; hasMapping: number }[]>([]);
    // codage -> { comptes par champ, locked (UTIVAL renseigne) }
    const [mapTp, setMapTp] = useState<Record<string, { comptes: Record<string, string>; locked: boolean }>>({});
    const [optComptesTp, setOptComptesTp] = useState<Record<string, { value: string; label: string }[]>>({});
    const [listeTp, setListeTp] = useState<any[]>([]);
    const [loadingListe, setLoadingListe] = useState(false);

    const appelCptTp = async (payload: any): Promise<any> => {
        const cypher = Crypter.encrypt(JSON.stringify(payload));
        const res = await axios.post(`${apiEndpoints.compteRegroup}/GererComptesTypepret`, null, {
            headers: { 'CypherGpt': cypher, 'Authorization': authHeader(), 'Content-Type': 'application/json' }
        });
        const raw = JSON.parse(Crypter.decrypt(res.data));
        return raw.Value ?? raw;
    };

    const chargerAgencesTp = async () => {
        const typepret = String(form.getFieldValue('TYPEPRET') ?? '').trim();
        if (!typepret) {
            SweetAlert.fire({ title: 'Type de prêt requis', icon: 'warning' });
            return;
        }
        setLoading(true);
        try {
            const [resA, resL] = await Promise.all([
                appelCptTp({ Action: 'AGENCES', Typepret: typepret }),
                appelCptTp({ Action: 'LISTE', Typepret: typepret })
            ]);
            setAgencesTp((resA?.Result?.Table ?? []).map((a: any) => ({
                codage: String(a.codage ?? a.CODAGE ?? ''),
                libelle: String(a.libelle ?? a.LIBELLE ?? ''),
                hasMapping: Number(a.hasMapping ?? a.HASMAPPING ?? 0)
            })));
            const map: Record<string, { comptes: Record<string, string>; locked: boolean }> = {};
            (resL?.Result?.Table ?? []).forEach((r: any) => {
                const ag = String(r.codage ?? r.CODAGE ?? '');
                if (!ag) return;
                const comptes: Record<string, string> = {};
                CHAMPS_TP.forEach(f => { comptes[f.prop] = champTp(r, f.prop); });
                map[ag] = { comptes, locked: champTp(r, 'utival').trim() !== '' };
            });
            setMapTp(map);
            setOptComptesTp({});
            setTypepretSel(typepret);
        } catch (e: any) {
            SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
        }
        setLoading(false);
    };

    // Charge les comptes GL de l'agence a l'ouverture de la liste (une fois)
    const chargerComptesAgenceTp = async (codage: string) => {
        if (optComptesTp[codage]) return;
        try {
            const res = await appelCptTp({ Action: 'COMPTES', Codage: codage });
            const opts = (res?.Result?.Table ?? []).map((c: any) => {
                const nc = String(c.numcpt ?? c.NUMCPT ?? '');
                return { value: nc, label: `${nc} - ${String(c.nomcpt ?? c.NOMCPT ?? '')}` };
            });
            setOptComptesTp(prev => ({ ...prev, [codage]: opts }));
        } catch (e: any) {
            console.log(e);
        }
    };

    const setChampTp = (codage: string, prop: string, v?: string) => {
        setMapTp(prev => {
            const cur = prev[codage] ?? { comptes: {}, locked: false };
            if (cur.locked) return prev;
            return { ...prev, [codage]: { ...cur, comptes: { ...cur.comptes, [prop]: v ?? '' } } };
        });
    };

    const nbChampsTp = (codage: string) =>
        CHAMPS_TP.filter(f => (mapTp[codage]?.comptes[f.prop] ?? '') !== '').length;

    const enregistrerTp = async () => {
        if (!typepretSel) return;
        setLoading(true);
        try {
            const items = agencesTp.map(a => ({
                Codage: a.codage,
                ...Object.fromEntries(CHAMPS_TP.map(f => [f.prop, mapTp[a.codage]?.comptes[f.prop] ?? '']))
            }));
            const res = await appelCptTp({
                Action: 'ENREGISTRER',
                Typepret: typepretSel,
                Utilisateur: Perss.coduti,
                Items: items
            });
            if (res?.StatutCode === 200) {
                SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                chargerAgencesTp();
                chargerListeTp();
            } else {
                SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
            }
        } catch (e: any) {
            SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
        }
        setLoading(false);
    };

    const chargerListeTp = async () => {
        setLoadingListe(true);
        try {
            const res = await appelCptTp({ Action: 'LISTE' });
            setListeTp(res?.Result?.Table ?? []);
        } catch (e: any) {
            console.log(e);
        }
        setLoadingListe(false);
    };

    // Charge le typepret de la ligne dans le mapping (onglet 1) : exploration
    const explorerTp = (r: any) => {
        form.setFieldValue('TYPEPRET', champTp(r, 'typepret'));
        chargerAgencesTp();
        setActiveTab('1');
    };

    const validerLigneTp = (r: any) => {
        const typepret = champTp(r, 'typepret');
        const codage = champTp(r, 'codage');
        SweetAlert.fire({
            title: 'Valider',
            text: `Valider les comptes de l'agence ${codage} (type ${typepret}) ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (rep) => {
            if (!rep.isConfirmed) return;
            setLoadingListe(true);
            try {
                const res = await appelCptTp({ Action: 'VALIDER', Typepret: typepret, Codage: codage, Utilisateur: Perss.coduti });
                if (res?.StatutCode === 200) {
                    SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoadingListe(false);
            chargerListeTp();
            if (typepretSel === typepret) chargerAgencesTp();
        });
    };

    const supprimerLigneTp = (r: any) => {
        const typepret = champTp(r, 'typepret');
        const codage = champTp(r, 'codage');
        SweetAlert.fire({
            title: 'Supprimer',
            text: `Supprimer les comptes de l'agence ${codage} (type ${typepret}) ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (rep) => {
            if (!rep.isConfirmed) return;
            setLoadingListe(true);
            try {
                const res = await appelCptTp({ Action: 'SUPPRIMER', Typepret: typepret, Codage: codage, Utilisateur: Perss.coduti });
                if (res?.StatutCode === 200) {
                    SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoadingListe(false);
            chargerListeTp();
            if (typepretSel === typepret) chargerAgencesTp();
        });
    };

    // Valide toutes les lignes non validees du typepret affiche (VALIDER, Typepret seul)
    const validerTypepret = () => {
        if (!typepretSel) return;
        SweetAlert.fire({
            title: 'Valider',
            text: `Valider les comptes prêt/découvert du type ${typepretSel} pour toutes les agences ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (rep) => {
            if (!rep.isConfirmed) return;
            setLoading(true);
            try {
                const res = await appelCptTp({ Action: 'VALIDER', Typepret: typepretSel, Utilisateur: Perss.coduti });
                if (res?.StatutCode === 200) {
                    SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoading(false);
            chargerListeTp();
            chargerAgencesTp();
        });
    };

    const colonnesAgencesTp = [
        {
            title: 'Agence', width: 260,
            render: (_: any, r: any) => <span><b>{r.codage}</b> — {r.libelle}</span>
        },
        {
            title: 'Comptes renseignés', width: 160, align: 'center' as const,
            render: (_: any, r: any) => {
                const n = nbChampsTp(r.codage);
                return <Tag color={n > 0 ? 'blue' : 'default'}>{n} / {CHAMPS_TP.length}</Tag>;
            }
        },
        {
            title: 'Statut', width: 110,
            render: (_: any, r: any) => mapTp[r.codage]?.locked
                ? <Tag color='green'>Validé</Tag>
                : <Tag color='orange'>En attente</Tag>
        }
    ];

    // Detail expande : les 10 comptes GL de l'agence
    const detailAgenceTp = (r: any) => {
        const locked = mapTp[r.codage]?.locked === true;
        return (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 10, padding: '4px 0' }}>
                {CHAMPS_TP.map(f => (
                    <div key={f.prop}>
                        <div style={{ fontSize: 11, fontWeight: 600, color: '#555', marginBottom: 2 }}>{f.label}</div>
                        <Select
                            size='small'
                            showSearch
                            allowClear
                            optionFilterProp='label'
                            style={{ width: '100%' }}
                            disabled={locked}
                            placeholder='— Choisir un compte GL —'
                            value={mapTp[r.codage]?.comptes[f.prop] || undefined}
                            onDropdownVisibleChange={(open: boolean) => { if (open) chargerComptesAgenceTp(r.codage); }}
                            options={optComptesTp[r.codage] ?? []}
                            onChange={(v?: string) => setChampTp(r.codage, f.prop, v)}
                        />
                    </div>
                ))}
            </div>
        );
    };

    // Filtrage de la liste par le champ recherche
    const filteredListeTp = listeTp.filter((r: any) =>
        Object.values(r).some(v => String(v ?? '').toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const colonnesListeTp = [
        {
            title: 'Type prêt', width: 90,
            sorter: (a: any, b: any) => champTp(a, 'typepret').localeCompare(champTp(b, 'typepret')),
            render: (_: any, r: any) => <b>{champTp(r, 'typepret')}</b>
        },
        {
            title: 'Libellé', width: 160,
            render: (_: any, r: any) => champTp(r, 'libTypepret') || '—'
        },
        {
            title: 'Agence', width: 130,
            sorter: (a: any, b: any) => champTp(a, 'codage').localeCompare(champTp(b, 'codage')),
            render: (_: any, r: any) => <span><b>{champTp(r, 'codage')}</b> — {champTp(r, 'libAgence')}</span>
        },
        // Les 10 comptes GL
        ...CHAMPS_TP.map(f => ({
            title: f.label, width: 130,
            render: (_: any, r: any) => champTp(r, f.prop) || '—'
        })),
        {
            title: 'Statut', width: 110,
            render: (_: any, r: any) => champTp(r, 'utival').trim() !== ''
                ? <Tag color='green'>Validé</Tag>
                : <Tag color='orange'>En attente</Tag>,
            filters: [
                { text: 'Validé', value: 'valide' },
                { text: 'En attente', value: 'attente' }
            ],
            onFilter: (v: any, r: any) => (champTp(r, 'utival').trim() !== '') === (v === 'valide')
        },
        {
            title: 'Créé le', width: 100,
            render: (_: any, r: any) => { const d = champTp(r, 'datcre'); return d ? new Date(d).toLocaleDateString() : '—'; },
            sorter: (a: any, b: any) => champTp(a, 'datcre').localeCompare(champTp(b, 'datcre'))
        },
        {
            title: 'Par', width: 80,
            render: (_: any, r: any) => champTp(r, 'utilis') || '—'
        },
        {
            title: 'Validé le', width: 100,
            render: (_: any, r: any) => { const d = champTp(r, 'datval'); return d ? new Date(d).toLocaleDateString() : '—'; }
        },
        {
            title: 'Par', width: 80,
            render: (_: any, r: any) => champTp(r, 'utival').trim() || '—'
        },
        {
            title: 'Actions', width: 240, fixed: 'right' as const,
            render: (_: any, r: any) => {
                const valide = champTp(r, 'utival').trim() !== '';
                return (
                    <Space size={2} wrap>
                        <Button size='small' onClick={() => explorerTp(r)}>Voir</Button>
                        {!valide && <Button size='small' type='primary' style={{ backgroundColor: '#116599' }} onClick={() => validerLigneTp(r)}>Valider</Button>}
                        {!valide && <Button size='small' danger onClick={() => supprimerLigneTp(r)}>Suppr.</Button>}
                    </Space>
                );
            }
        }
    ];

    // Contenu de l'onglet 2 : meme squelette (.border + .bordure1) que l'onglet 1
    const listeTypepret = (
        <Box fontStyle="inherit" className="border" sx={{ width: '85%', minWidth: 0, boxSizing: 'border-box' }}>
            <legend style={{ textAlign: 'center', paddingLeft: 10, borderRadius: 10 }}>
                Liste des comptes prêt et découvert
            </legend>
            <fieldset className="bordure1" style={{ width: '100%', boxSizing: 'border-box', marginTop: -20, padding: '16px', minWidth: 0 }}>
                <Box sx={{ width: '100%', overflowX: 'auto' }}>
                    <Box sx={{ mb: 2 }}>
                        <TextField
                            label="Recherche"
                            variant="outlined"
                            fullWidth
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            size="small"
                            InputLabelProps={{ sx: { fontWeight: 'bold' } }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon color="action" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                    <AntTable
                        size='small'
                        columns={colonnesListeTp as any}
                        dataSource={filteredListeTp}
                        rowKey={(r: any) => `${champTp(r, 'typepret')}-${champTp(r, 'codage')}`}
                        loading={loadingListe}
                        scroll={{ y: 320, x: 'max-content' }}
                        pagination={{
                            pageSize: 10,
                            showSizeChanger: true,
                            pageSizeOptions: [10, 25, 50, 100],
                            showTotal: (t: number) => `${t} ligne(s)`
                        }}
                    />
                </Box>
            </fieldset>
        </Box>
    );

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Génération comptes pret et découvert
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    {/*
                      La zone des boutons (.bG) est en absolute a ~89% : ce conteneur
                      reste a gauche (85%), sans absolute ni overflow:hidden (qui
                      coupaient le contenu). minWidth:0 : .tabItem est en flex.
                    */}
                    <Box
                        fontStyle="inherit"
                        className="border"
                        sx={{
                            width: '85%',
                            minWidth: 0,
                            boxSizing: 'border-box',
                        }}
                    >
                        <legend style={{ textAlign: "center", paddingLeft: 10, borderRadius: 10 }} > Comptes prêt et découvert par type de prêt </legend>
                        <fieldset className="bordure1" style={{ width: '100%', boxSizing: 'border-box', marginTop: -20, padding: '16px', minWidth: 0 }}>
                            <Grid container spacing={0} alignItems="center">
                                <Grid item xs={12}>
                                    <SearchModal
                                        disabled={false}
                                        width={0}
                                        Titre="Recherche"
                                        label="Type prêt"
                                        name="TYPEPRET"
                                        Taille1={'100%'}
                                        Parametre={searchPlancp}
                                        Taille2={'100%'}
                                        form={form}
                                        ExecuteafterSelect1={() => chargerAgencesTp()}
                                    />
                                </Grid>
                            </Grid>
                            {/* Tableau : agences -> 10 comptes GL par agence (ligne expandable) */}
                            <Box sx={{ overflowX: 'auto', width: '100%', marginTop: 2 }}>
                                {agencesTp.length === 0 ? (
                                    <Box style={{ textAlign: 'center', color: '#999', margin: 16 }}>
                                        Choisissez un type de prêt puis chargez les agences
                                    </Box>
                                ) : (
                                    <>
                                        <AntTable
                                            size='small'
                                            columns={colonnesAgencesTp as any}
                                            dataSource={agencesTp}
                                            rowKey={(r: any) => r.codage}
                                            pagination={false}
                                            scroll={{ y: 400, x: 'max-content' }}
                                            expandable={{
                                                expandedRowRender: (r: any) => detailAgenceTp(r)
                                            }}
                                        />
                                        <Box style={{ marginTop: 12, textAlign: 'right' }}>
                                            <Tag color='geekblue' style={{ marginRight: 8 }}>
                                                Une ligne par agence : dépliez pour renseigner les comptes
                                            </Tag>
                                            <Tag color='orange' style={{ marginRight: 8 }}>
                                                Les lignes validées ne sont pas modifiables
                                            </Tag>
                                        </Box>
                                    </>
                                )}
                            </Box>
                        </fieldset>
                    </Box>
                </div>
            </>,
        },
        {
            key: '2',
            label: (
                <span id='x'>
                    <ContactsOutlined />
                    Liste comptes prêt et découvert
                </span>
            ),
            children: <div className='tabItem'>{listeTypepret}</div>,
        }
    ];


    function consult() {



    }


    // function Onfinish
    const onFinish = (values: any) => {
        
    var compteCommis: McomptesPretEtDecouvert = values;
    compteCommis.IDTYPEPRET= currentDataBranch?.IDTYPEPRET || 0;
    compteCommis.TYPEPRET= form.getFieldValue("TYPEPRET") //currentDataBranch?.CODCOM || '';
    compteCommis.IDPLCPTINTIMP= form.getFieldValue("IDPLCPTINTIMP");
    compteCommis.IDPLCPTTVAIMP= form.getFieldValue("IDPLCPTTVAIMP");
    compteCommis.IDPLCPTINTPAIE= form.getFieldValue("IDPLCPTINTPAIE");
    compteCommis.IDPLCPTCOMPTAX= form.getFieldValue("IDPLCPTCOMPTAX");
    compteCommis.IDPLCPTPENPAIE= form.getFieldValue("IDPLCPTPENPAIE");
    compteCommis.IDPLCPTPROMESS= form.getFieldValue("IDPLCPTPROMESS");
    compteCommis.IDPLCPTGARAN= form.getFieldValue("IDPLCPTGARAN");
    compteCommis.IDPLCPTINTDOUT= form.getFieldValue("IDPLCPTINTDOUT");
    compteCommis.IDPLCPTTVADOUT= form.getFieldValue("IDPLCPTTVADOUT");
    compteCommis.IDPLCPTPROVCRDOUT= form.getFieldValue("IDPLCPTPROVCRDOUT");

    compteCommis.CODAGE= Perss.codage;
   
    compteCommis.UTILIS=  Perss.coduti;
    compteCommis.DATCRE= Perss.datjour;
    compteCommis.UTIVAL= Perss.coduti;
    compteCommis.DATVAL= Perss.datjour;
    compteCommis.CHOIX= choix;
     compteCommis.LIBELLE = '';
         
        // CompteReg.idcptregpt = currentDataBranch?.IDCPTREGPT ||0;//CompteReg.idcptregpt;
        // CompteReg.idplan =  form.getFieldValue("IDPLAN") //CompteReg.idplan;
        //  CompteReg.codage = Perss.codage;
        // CompteReg.cptregpt = form.getFieldValue("CPTREGPT") //CompteReg.cptregpt;
        // CompteReg.utilis = Perss.coduti;
        // CompteReg.datcre=Perss.datjour;
        // CompteReg.utival=Perss.coduti;
        // CompteReg.datval=Perss.datjour
        //  CompteReg.choix = choix;                    
        // CompteReg.libelle = form.getFieldValue("NOMCPT") //CompteReg.libelle;
        // //CompteReg.nomcpt = choix;
        let data = Crypter.encrypt(JSON.stringify(compteCommis));
        
        // ************* pour le consult
        if (sbmit == 'Consult') {
            chargerListeTp();
            // ************* mis a jour  *********************
        } else if (sbmit=='Enreg'){
            // alert("yeteooo aaa")
           // alert(data)
            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCptTypepret,
                                headers: {
                                'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
            SweetAlert.fire({})
      
        } else if (sbmit=='Add'){
           // alert("modif")
                if (form.getFieldValue("IDPLAN") != "") {
                            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCptTypepret,
                                headers: {
                                    'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
                        }else {
                            SweetAlert.fire({ title: "Warning", text: "Veuillez remplir le champ Plan Comptable", icon: "warning" })
                        }
        }
    }
    


    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir le champs obligatoire", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir le champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                {/* <Form disabled={!FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}> */}
                 <Form disabled={!FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish}  style={{ minWidth: 'auto', maxWidth: 'auto' }}>

                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                {/* Recharge la liste + le mapping du typepret affiche */}
                                <Button size='large' className='bt_add' disabled={loading || loadingListe}
                                    onClick={() => { chargerListeTp(); if (typepretSel) chargerAgencesTp(); }}
                                    type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                {/* Enregistre en masse le mapping du typepret (onglet 1) */}
                                <Button size='large' className='bt_add' onClick={enregistrerTp}
                                    disabled={!typepretSel || agencesTp.length === 0 || loading}
                                    type="ghost" htmlType="button" block>
                                    Enregistrer
                                </Button>
                                {/* Valide toutes les lignes non validees du typepret affiche */}
                                <Button size='large' className='bt_add' disabled={!typepretSel || loading}
                                    onClick={validerTypepret}
                                    type="ghost" htmlType="button" block>
                                    Valider
                                </Button>
                                <Button size='large' className='bt_add' type="ghost" htmlType="button" block
                                    onClick={() => {
                                        form.resetFields();
                                        setAgencesTp([]);
                                        setMapTp({});
                                        setOptComptesTp({});
                                        setTypepretSel('');
                                        setSearchTerm('');
                                        setActiveTab('1');
                                        setChoix('I');
                                    }}>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" activeKey={activeTab} onChange={setActiveTab} items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default ComptesPretEtDecouvert;